import React, { useState } from "react";

type Props = {
  title: any;
  icon?: any;
  desc?: string;
  classname?: string;
  whiteIcon?: any;
};

function Cards({ title, icon, desc, classname, whiteIcon }: Props) {
  const [enter, setEnter] = useState(false);
  const MouseEnter = () => {
    setEnter(true);
  };
  const MouseLeave = () => {
    setEnter(false);
  };
  const imgsize = enter ? "wx-80 hx-80" : "wx-120 hx-120";
  const top = enter ? "pt-44" : "pt-64";
  return (
    <>
      <div className="d-flex justify-content-center">
        <div
          className={`${classname} ${top} text-center card2-container`}
          onMouseEnter={MouseEnter}
          onMouseLeave={MouseLeave}
        >
          <img
            className={`${imgsize} card2-image`}
            src={enter ? whiteIcon : icon}
            alt={icon}
          />
          <div>
            <p className="dark-header font-family-roboto font-20 fonts-800 line-35 pb-20 pt-20 card2-title">
              {title}
            </p>
            {desc && (
              <p className="text-white-color text-center font-18 fonts-400 line-22 font-family-roboto px-1 card2-desc">
                {enter ? desc : ""}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Cards;
